import { EditMerch } from '@webapp/store/merch/action-creators';
import AppState from '@webapp/store/state';
import * as React from 'react';
import { useRouteMatch } from 'react-router';
import MerchPage from '../merch';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

interface MerchPageProps {
  className?: string;
  artistId?: string;
}

interface MerchPageStateProps {
  editMerch: (artistId: string, productId: string) => EditMerch;
}

const mapStateToProps = (state: AppState) => ({
  artistId: state.artist.active?.id,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  editMerch: (artistId: string, productId: string) =>
    dispatch(new EditMerch(artistId, productId)),
});

const MerchEditPage: React.FC<MerchPageProps & MerchPageStateProps> = ({
  editMerch,
  artistId,
}) => {
  const match = useRouteMatch<{ merchId: string }>();
  const merchId = match.params.merchId;

  React.useEffect(() => {
    if (artistId) {
      editMerch(artistId, merchId);
    }
  }, [editMerch, artistId, merchId]);

  return <MerchPage isEdit />;
};

export default connect(mapStateToProps, mapDispatchToProps)(MerchEditPage);
